import { render, staticRenderFns } from "./PriceStructView.vue?vue&type=template&id=22fe9ab0&scoped=true"
import script from "./PriceStructView.vue?vue&type=script&lang=js"
export * from "./PriceStructView.vue?vue&type=script&lang=js"
import style0 from "./PriceStructView.vue?vue&type=style&index=0&id=22fe9ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe9ab0",
  null
  
)

export default component.exports